/**
 * MainLayout Component
 * 
 * A reusable layout component that provides consistent structure across all pages.
 * Implements Clean Architecture principles with modular design and single responsibility.
 * 
 * Features:
 * - Consistent header and footer across all pages
 * - Responsive design with proper spacing
 * - SEO-friendly structure
 * - Accessibility support
 * - Theme and i18n integration
 */

import React from 'react';
import Header from './Header';
import Footer from './Footer';
import ErrorReport from '@/components/common/ErrorReport';

interface MainLayoutProps {
  children: React.ReactNode;
  className?: string;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, className = '' }) => {
  return (    <div className={`min-h-screen flex flex-col gradient-bg ${className}`}>
      <Header />
      <main className="flex-1 flex flex-col">
        {children}
      </main>
      <Footer />
      <ErrorReport />
    </div>
  );
};

export default MainLayout;
